export const importText=value=>String(value??"").normalize("NFD").replace(/\p{M}/gu,"").toLowerCase().replace(/[^\p{L}\p{N}]+/gu," ").trim();
const words=value=>importText(value).split(/\s+/).filter(Boolean);
const compact=value=>importText(value).replace(/ /g,"");
const uniqueBest=ranked=>{
  ranked.sort((a,b)=>b.score-a.score);
  return ranked[0]?.score>0 && (!ranked[1] || ranked[0].score>ranked[1].score)?ranked[0].value:null;
};

export function matchImportColor(hint,colors) {
  const tokens=new Set(words(hint));
  if(!tokens.size)return null;
  return uniqueBest(colors.filter(c=>c.active!==false && (!c.materialType || importText(c.materialType)==="mdf")).map(color=>{
    const name=words(color.name),group=words(color.groupName);
    // A finish/group alone must never select an arbitrary colour.
    if(!name.length || !name.every(t=>tokens.has(t)))return {value:color,score:0};
    const combined=new Set([...name,...group]);
    const matches=[...combined].filter(t=>tokens.has(t));
    const coverage=matches.length/tokens.size;
    return {value:color,score:coverage<.5?0:100*coverage+name.length+group.filter(t=>tokens.has(t)).length*2};
  }));
}

export function matchImportMilling(hint,millings,color) {
  const key=compact(hint);
  if(!key)return null;
  // Match the backend ImportMaterialMatcher: assignments guide manual selection,
  // but must not discard an explicitly named, unambiguous import milling.
  const candidates=millings.filter(m=>m.active!==false && (!m.materialType || importText(m.materialType)==="mdf"));
  return uniqueBest(candidates.map(m=>({value:m,score:
    [m.name,m.code].some(v=>v&&compact(v)===key)?100:
    [m.name,m.code].some(v=>v&&(` ${importText(v)} `).includes(` ${importText(hint)} `))?50:0
  })));
}

export function resolveMdfImageItem(item, colors, millings) {
  if (item.importMaterial !== "MDF") return item;
  const color = colors.find(c => String(c.colorId) === String(item.colorId))
    ?? matchImportColor(item.colorHint, colors);
  const milling = matchImportMilling(item.codFrezare, millings, color);
  const variant = matchImportVariant(item.details, milling);
  return { ...item, colorId: color?.colorId ?? item.colorId ?? null,
    millingId: milling?.millingId ?? null,
    milling: milling ? { millingId: milling.millingId } : item.milling,
    millingVariantId: variant?.variantId ?? null };
}

export function matchImportVariant(observations,milling) {
  const text=` ${importText(observations)} `;
  if(!text.trim()||!milling)return null;
  const matches=(milling.variants||[]).filter(v=>(!v.selectionMode||v.selectionMode==="manual")&&v.variantId&&importText(v.name)&&text.includes(` ${importText(v.name)} `));
  return matches.length===1?matches[0]:null;
}
